

import React, { lazy, Suspense } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

import "./index.css";
import "leaflet/dist/leaflet.css";
import Authpages from "./Component/LandingPage/Authpages.jsx";
import { SidebarProvider } from "./context/SidebarContext.jsx";// ← Make sure this path is correct
import { LoaderProvider } from "./context/LoaderProvider.jsx";
import HeroSection from "./Component/LandingPage/HeroSection.jsx";
// ================================= Nav Bars ============================================> //
import ProtectedRoute from "./Component/Modules/Landingmanagment/ProtectedRoute";
import Landingnavbar from "./Component/Layouts/Landingnavbar.jsx";
import LandingSideBar2 from "./Component/Layouts/LandingSideBar2.jsx";
import Foodandbevaragenavbar from "./Component/Layouts/Foodandbevaragenavbar.jsx";
// import Cateringsnavbars from "./Component/Layouts/Cateringsnavbars.jsx";
// import Grocerysnavbar from "./Component/Layouts/Grocerysnavbar.jsx";
import VendorForgetpassword from "./Component/ForgotPassword/VendorForgetpassword.jsx";
import EmailSentSuccess from "./Component/ForgotPassword/EmailSentSuccess.jsx";
import Termsandcondions from "./Component/Modules/Accountandhistory/Termsandcondions";
import NavBars from "./Component/Modules/UserModule/UserF&B/Newnavbar.jsx";
import Eventsnavbars from "./Component/Layouts/Eventsnavbar.jsx";
// ============================================== Food and Beverages ================================

import Demomenuadvertsiment from './demoscrenn/Demomenuadvertsiment.jsx';




const FoodDashboard = lazy(() => import("./Component/Modules/FoodandBeverages/FoodDashboard.jsx"));
const Foodbeveragescompany = lazy(() => import("./Component/Modules/FoodandBeverages/Foodbeveragescompany"));
const Foodsettings = lazy(() => import("./Component/Modules/FoodandBeverages/Foodsettings"));
const FoodandbeveragesMenu = lazy(() => import("./Component/Modules/FoodandBeverages/FoodandbeveragesMenu"));
const Menudatas = lazy(() => import("./Component/Modules/Menumanagment/Food/Menudatas"));
const Foodordermanagment = lazy(() => import("./Component/Modules/FoodandBeverages/Foodordermanagment"));



const Foodchefmanagment = lazy(() => import("./Component/Modules/FoodandBeverages/Foodchefmanagment"));
const Foodwaitermanagment = lazy(() => import("./Component/Modules/FoodandBeverages/Foodwaitermanagment"));
const FoodAccuont = lazy(() => import("./Component/Modules/FoodandBeverages/FoodAccuont"));
const Foodandbeveragespromotions = lazy(() => import("./Component/Modules/FoodandBeverages/Foodandbeveragespromotions"));
const Foodtablemanagment = lazy(() => import("./Component/Modules/FoodandBeverages/Foodtablemanagment"));



const FoodandbeveragesInvetory = lazy(() => import("./Component/Modules/FoodandBeverages/FoodandbeveragesInvetory"));
const Foodandreporanalysis = lazy(() => import("./Component/Modules/FoodandBeverages/Foodandreporanalysis"));
const Landingpagesubscription = lazy(() => import("./Component/Modules/Landingmanagment/Landingpagesubscription"));
const FoodSupportSystem = lazy(() => import("./Component/Modules/FoodandBeverages/FoodSupportSystem.jsx"));
const TeamManagment = lazy(() => import("./Component/Modules/TeamManagment/TeamManagment.jsx"));



const Subscriptionpage = lazy(() => import("./Component/Modules/Landingmanagment/Subscriptionpage"));
const NotificationContext = lazy(() => import("./context/NotificationContext.jsx"));
const FoodandbeveragesSupportSystem = lazy(() => import("./Component/Modules/FoodandBeverages/FoodandbeveragesSupportSystem.jsx"));
const SubscriptionPackages = lazy(() => import("./Component/Modules/Landingmanagment/SubscriptionPackages.jsx"));
const Foodratings = lazy(() => import("./Component/Modules/FoodandBeverages/Foodratings.jsx"));




const Waitermenu = lazy(() => import("./Component/Modules/TableManagment/Waitermenu"));
const TableCart = lazy(() => import("./Component/Modules/TableManagment/TableCart"));
const Supscriptionrenewal = lazy(() => import("./Component/Modules/Accountandhistory/Supscriptionrenewal"));
const Foodwaiterdata = lazy(() => import("./Component/Modules/FoodandBeverages/Foodwaiterdata.jsx"));
const BusinessOrders = lazy(() => import("./Component/Modules/Ordermanagment/Food/BusinessOrders.js"));




const MenuAdvertisement = lazy(() => import("./Component/Modules/Menumanagment/Food/MenuAdvertisement.js"));
const FinancialDashoard = lazy(() => import("./Component/Modules/FoodandBeverages/FinancialDashoard.jsx"));
const SalesManagment = lazy(() => import("./Component/Modules/SalesManagment/SalesManagment.jsx"));



// =========================================== User F & B =============================================================

const UserFoodLandingPage = lazy(() => import("./Component/Modules/UserModule/UserF&B/UserFoodLandingPage.jsx"));
const Newmenuiteam = lazy(() => import("./Component/Modules/UserModule/UserF&B/UserMenu/Newmenuiteam.jsx"));
const CartsData = lazy(() => import("./Component/Modules/UserModule/UserF&B/UserCart/CartsData.jsx"));
const UserCateringLandingPage = lazy(() => import("./Component/Modules/UserModule/UserCS/UserCateringLandingPage.jsx"));
const Privacy = lazy(() => import("./Component/Modules/FoodandBeverages/Privacy.jsx"));



const Refer = lazy(() => import("./Component/Modules/RefereandEarn/Refer.jsx"));
const Rewardslanding = lazy(() => import("./Component/Modules/FoodandBeverages/Rewardslanding.jsx"));
const Demosidebar = lazy(() => import("./demoscrenn/Demosidebar.jsx"));
const DemoDashboard = lazy(() => import("./demoscrenn/DemoDashboard.jsx"));
const Demobusinessprofile = lazy(() => import("./demoscrenn/Demobusinessprofile"));


const Denisettingcantrol = lazy(() => import('./demoscrenn/Denisettingcantrol.jsx'));
const Demoservices = lazy(() => import('./demoscrenn/Demoservices'));
const Demoordermanagement = lazy(() => import('./demoscrenn/Demoordermanagement'));
const Demochefmanagement = lazy(() => import('./demoscrenn/Demochefmanagement'));
const Demodeliverymangement = lazy(() => import('./demoscrenn/Demodeliverymangement'));



const Demoteam = lazy(() => import('./demoscrenn/Demoteam'));
const Demofoodacountdata = lazy(() => import('./demoscrenn/Demofoodacountdata'));
const Demosupport = lazy(() => import('./demoscrenn/Demosupport')); // fixed path
const Demolegealcomplance = lazy(() => import('./demoscrenn/Demolegealcomplance'));
const Demoreportanylisis = lazy(() => import('./Component/Modules/FoodandBeverages/Demoreportanylisis.jsx'));



const DemoFinancialdashbord = lazy(() => import('./Component/Modules/FoodandBeverages/DemoFinancialdashbord'));
const Demolandiningpage = lazy(() => import('./Component/Modules/Landingmanagment/Demolandiningpage.jsx'));
const TermsAndConditions = lazy(() => import('./Component/Subscriptions/TermsAndConditions.jsx'));






function Layout() {
  const location = useLocation();

  const showLayout1 = location.pathname === "/mainnavbar" || location.pathname === "/delivery" || location.pathname === "/chef" || location.pathname === "/waitermanagement" || location.pathname === "/mainsidebar" || location.pathname === "/Newmainlandingpage";
  const showLayout2 = location.pathname === "/fooddashboard" || location.pathname === "/foodsupportsystem" || location.pathname === "/foodbeveragescompany" || location.pathname === "/foodsettings" || location.pathname === "/foodandbeveragesMenu" || location.pathname === "/menuiteams" || location.pathname === "/notificationcontext" || location.pathname === "/salesmanagment"
    || location.pathname === "/foodordermanagment" || location.pathname === "/foodchefmanagment" || location.pathname === "/fooddelivarymanagment" || location.pathname === "/foodAccuontdata" || location.pathname === "/foodandbeveragespromotions" || location.pathname === "/foodtablemanagment" || location.pathname === "/financialdashoard"
    || location.pathname === "/foodandbeveragesInvetory" || location.pathname === "/foodandreporanalysis" || location.pathname === "/foodcart" || location.pathname === "/subscriptionrenewal" || location.pathname === "/foodsupportsystem" || location.pathname === "/businessorders" || location.pathname === "/landingpagesubscription"
    || location.pathname === "/teammanagment" || location.pathname === "/subscriptionpackages" || location.pathname === "/foodandbeveragessupportsystem" || location.pathname === "/foodratings" || location.pathname === "/waitermenu" || location.pathname === "/tableCart" || location.pathname === "/foodwaiterdata" || location.pathname === "/referandearn" || location.pathname === "/rewardslanding";

  const showLayout3 = location.pathname === "/cateringdashboard" || location.pathname === "/cateringlading" || location.pathname === "/cateringsprofilepage" || location.pathname === "/cateringssettingpage" || location.pathname === "/cateringsmenuaddingpage" || location.pathname === "/cateringsorderspage"
    || location.pathname === "/caterigsaccount" || location.pathname === "/cateringspromotionspage" || location.pathname === "/cateringsreportanalysis" || location.pathname === "/cateringrenewal" || location.pathname === "/cateringpackageorders" || location.pathname === "/cateringleadconfirmedorders";

  const showLayout6 = location.pathname === '/grocerydashboard' || location.pathname === "/groceryladingpage" || location.pathname === "/groceryprofiledata" || location.pathname === "/grocerysettingsdata" || location.pathname === "/groceryandbeveragesMenu" || location.pathname === "/groceryordermanagment" || location.pathname === "/grocerychefmanagment"
    || location.pathname === "/grocerywaitermanagment" || location.pathname === "/groceryaccuontdata" || location.pathname === "/groceryandbeveragespromotions" || location.pathname === "/groceryandbeveragesInventory" || location.pathname === "/groceryandreporanalysis"
    || location.pathname === "/grocerymenudatas" || location.pathname === "/grocerycart" || location.pathname === "/groceryorders";

  const showLayout7 = location.pathname === "/eventsdashboard" || location.pathname === "/eventsprofilepage" || location.pathname === "/eventsaccounthistory" || location.pathname === "/eventspromotions" || location.pathname === "/eventsreportanalysis";

  // const mainlayout = location.pathname === "/mainlandingpage";

  const userFBlayout = location.pathname === "/userfoodlandingpage" || location.pathname === "/cartsdata" || location.pathname === "/usercateringlandingpage";

  const showLayout12 = location.pathname === "/demo-dashboard" || location.pathname === "/Demosidebar" || location.pathname === "/Demobusinessprofile" || location.pathname === "/Denisettingcantrol" || location.pathname === "/Demoservices" || location.pathname === "/Demoordermanagement" || location.pathname === "/Demochefmanagement" || location.pathname === "/Demodeliverymangement" || location.pathname === "/Demoteam" || location.pathname === "/Demofoodacountdata" || location.pathname === "/Demosupport" || location.pathname === "/Demolegealcomplance" || location.pathname === "/Demoreportanylisis" || location.pathname === "/DemoFinancialdashbord" || location.pathname === "/Demolandiningpage" || location.pathname === "/Landingpagesubscription";


  return (
    <div style={{ display: "flex", flexDirection: "column" }}>

      {showLayout1 && <Landingnavbar />}
      {showLayout2 && <Foodandbevaragenavbar />}
      {/* {showLayout3 && <Cateringsnavbars />}
      {showLayout6 && <Grocerysnavbar />} */}

      {showLayout7 && <Eventsnavbars />}

      {userFBlayout && <NavBars />}
      <div style={{ display: "flex", flexGrow: 1 }}>


        {/* {showLayout1 && <LandingSideBar2 />} */}
        {showLayout2 && <LandingSideBar2 />}
        {showLayout3 && <LandingSideBar2 />}
        {showLayout6 && <LandingSideBar2 />}
        {showLayout7 && <LandingSideBar2 />}
        {showLayout12 && <Demosidebar />}





        <div style={{ flexGrow: 1 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              {/* <Route path="/" element={<Authpages />} /> */}
              <Route path="/" element={ <HeroSection />} />

              <Route path="/vendorforgetpassword/:token" element={<VendorForgetpassword />} />
              <Route path="/emailsentsuccess" element={<EmailSentSuccess />} />
              <Route path="/termsandcondions" element={<ProtectedRoute><Termsandcondions /></ProtectedRoute>} />






              {/* ================================== FOOD AND BEVERAGES ========================== */}
              <Route path="/fooddashboard" element={<ProtectedRoute><FoodDashboard /></ProtectedRoute>} />
              <Route path="/foodbeveragescompany" element={<ProtectedRoute><Foodbeveragescompany /></ProtectedRoute>} />
              <Route path="/foodsettings" element={<ProtectedRoute>< Foodsettings /></ProtectedRoute >} />
              <Route path="/foodandbeveragesMenu" element={<ProtectedRoute>< FoodandbeveragesMenu /></ProtectedRoute >} />
              <Route path="/menuiteams" element={<ProtectedRoute><Menudatas /></ProtectedRoute>} />
              <Route path="/foodordermanagment" element={<ProtectedRoute>< Foodordermanagment /></ProtectedRoute >} />
              < Route path="/foodchefmanagment" element={<ProtectedRoute>< Foodchefmanagment /></ProtectedRoute >} />
              <Route path="/foodwaiterdata" element={<ProtectedRoute><Foodwaiterdata /></ProtectedRoute>} />
              < Route path="/fooddelivarymanagment" element={<ProtectedRoute>< Foodwaitermanagment /></ProtectedRoute >} />
              < Route path="/foodAccuontdata" element={<ProtectedRoute>< FoodAccuont /></ProtectedRoute >} />
              < Route path="/foodandbeveragespromotions" element={<ProtectedRoute>< Foodandbeveragespromotions /></ProtectedRoute >} />
              < Route path="/foodandbeveragesInvetory" element={<ProtectedRoute>< FoodandbeveragesInvetory /></ProtectedRoute >} />
              < Route path="/foodtablemanagment" element={<ProtectedRoute>< Foodtablemanagment /></ProtectedRoute >} />
              < Route path="/foodandreporanalysis" element={<ProtectedRoute>< Foodandreporanalysis /></ProtectedRoute >} />
              <Route path="/subscriptionpackages" element={<ProtectedRoute><SubscriptionPackages /></ProtectedRoute>} />
              < Route path="/landingpagesubscription" element={< Landingpagesubscription />} />
              <Route path="/foodsupportsystem" element={<ProtectedRoute><FoodSupportSystem /></ProtectedRoute>} />
              <Route path="/teammanagment" element={<ProtectedRoute> <TeamManagment /></ProtectedRoute>} />
              <Route path="/subscriptionpage" element={<Subscriptionpage />} />
              < Route path="/notificationcontext" element={< ProtectedRoute > <NotificationContext /></ProtectedRoute >} />
              <Route path="/foodandbeveragessupportsystem" element={<ProtectedRoute><FoodandbeveragesSupportSystem /></ProtectedRoute>} />
              <Route path="/foodratings" element={<ProtectedRoute><Foodratings /></ProtectedRoute>} />
              <Route path="/waitermenu" element={<ProtectedRoute> <Waitermenu /></ProtectedRoute>} />
              <Route path="/tableCart" element={<ProtectedRoute><TableCart /></ProtectedRoute>} />
              <Route path="/subscriptionrenewal" element={<Supscriptionrenewal />} />
              <Route path="/businessorders" element={<ProtectedRoute> <BusinessOrders /></ProtectedRoute>} />
              <Route path="/menuadvertisement" element={<ProtectedRoute> <MenuAdvertisement /></ProtectedRoute>} />
              <Route path="/salesmanagment" element={<ProtectedRoute> <SalesManagment /></ProtectedRoute>} />
              <Route path="/financialdashoard" element={<ProtectedRoute > <FinancialDashoard /> </ProtectedRoute>} />


              {/* ==================================== User F & B ===================================== */}
              <Route path="/userfoodlandingpage" element={<ProtectedRoute> <UserFoodLandingPage /></ProtectedRoute>} />
              <Route path="/Newmenuiteam/:vendorId" element={<Newmenuiteam />} />
              <Route path="/cartsdata" element={<CartsData />} />
              <Route path="/privacy-policys" element={<Privacy />} />



              {/* ==================================== User Catering ===================================== */}
              <Route path="/usercateringlandingpage" element={<ProtectedRoute> <UserCateringLandingPage /></ProtectedRoute>} />


              {/* ==================================== Refere and Earn ===================================== */}
              <Route path="/referandearn" element={<ProtectedRoute> <Refer /></ProtectedRoute>} />
              <Route path="/rewardslanding" element={<ProtectedRoute> <Rewardslanding /></ProtectedRoute>} />



              {/* demoscrennallllllllll */}
              <Route path="/demo-dashboard" element={<DemoDashboard />} />
              <Route path="/Demobusinessprofile" element={<Demobusinessprofile />} />
              <Route path="/Denisettingcantrol" element={<Denisettingcantrol />} />
              <Route path="/Demoservices" element={<Demoservices />} />
              <Route path="/Demoordermanagement" element={< Demoordermanagement />} />
              <Route path="/Demochefmanagement" element={< Demochefmanagement />} />

              <Route path="/Demodeliverymangement" element={<Demodeliverymangement />} />
              <Route path="/Demoteam" element={< Demoteam />} />
              <Route path="/Demofoodacountdata" element={<Demofoodacountdata />} />
              <Route path="/Demosupport" element={<Demosupport />} />
              <Route path="/Demolegealcomplance" element={<Demolegealcomplance />} />
              <Route path="/Demoreportanylisis" element={<Demoreportanylisis />} />
              <Route path="/DemoFinancialdashbord" element={<DemoFinancialdashbord />} />
              <Route path="/Demolandiningpage" element={<Demolandiningpage />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
               <Route path="/Demomenuadvertsiment" element={<Demomenuadvertsiment />} />




            </Routes >
          </Suspense>
        </div>
      </div >
    </div >
  );
}




function App() {
  return (

    <LoaderProvider>
      <SidebarProvider>
        <Router>
          <Layout />
        </Router>
      </SidebarProvider>
    </LoaderProvider>

  );
}



export default App;



